import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class ConnectAnalyticsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  redirect(): void {
    if (this.abilities.cannot('visit connect analytics')) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
